// AutoMats Mock Data
export const products = [
  {
    id: 1,
    category: "All-Weather Mats",
    name: "All-Weather 5400 Logo",
    description: "Trim to fit any application with protective coated logo",
    features: [
      "Available in 2 or 4 piece",
      "Griplock backing with retention punch outs",
      "100% Recycled Material",
      "Deep grooves & raised edges",
      "Easy clean maintenance"
    ],
    price: { fourPiece: 17.00, twoPiece: 14.00 },
    minOrder: 25,
    colors: ["Black"],
    image: "/api/placeholder/400/300"
  },
  {
    id: 2,
    category: "All-Weather Mats",
    name: "All-Weather GM Custom Fit Logo",
    description: "Custom fit for Silverado, Sierra, Yukon, Tahoe, and Suburban",
    features: [
      "Custom fit with grommet placement",
      "Protective coated logo",
      "Griplock backing with retention punch outs",
      "Honeycomb design",
      "100% Recycled Material"
    ],
    price: { fourPiece: 21.00 },
    minOrder: 25,
    colors: ["Black"],
    image: "/api/placeholder/400/300"
  },
  {
    id: 3,
    category: "Carpet Mats",
    name: "Carpet 6000",
    description: "Universal application with premium 12 oz construction",
    features: [
      "Universal application",
      "Available in 4 piece",
      "Griplock backing",
      "12 oz premium construction",
      "100% Recycled Material"
    ],
    price: { fourPiece: 10.75 },
    minOrder: 8,
    colors: ["Black", "Tan", "Charcoal", "Grey"],
    image: "/api/placeholder/400/300"
  },
  {
    id: 4,
    category: "Custom Solutions",
    name: "Custom Cuts",
    description: "Custom cut from template for specific manufacture and model",
    features: [
      "Made from specific templates",
      "Grommets available",
      "Griplock Nib backing",
      "12 oz construction",
      "100% Recycled Material"
    ],
    price: "Call for Pricing",
    minOrder: "Varies",
    colors: ["Black", "Tan", "Charcoal", "Grey"],
    image: "/api/placeholder/400/300"
  },
  {
    id: 5,
    category: "Specialty Mats",
    name: "Utility Mat Logo",
    description: "33\" x 20\" boot mat for RV/Tailgate applications",
    features: [
      "33\" x 20\" size",
      "Boot mat design",
      "RV/Tailgate compatible",
      "Honeycomb design",
      "100% Recycled Material"
    ],
    price: { single: 16.50 },
    minOrder: 25,
    colors: ["Black"],
    image: "/api/placeholder/400/300"
  }
];

export const productCategories = [
  {
    name: "All-Weather Mats",
    description: "Heavy-duty protection against mud, water, and snow",
    icon: "Shield",
    productCount: 4
  },
  {
    name: "Carpet Mats",
    description: "Premium carpeted mats with superior comfort and style",
    icon: "Car",
    productCount: 3
  },
  {
    name: "Custom Solutions",
    description: "Tailored solutions for specific vehicle makes and models",
    icon: "Settings",
    productCount: 8
  },
  {
    name: "Specialty Mats",
    description: "Utility and specialty applications for various needs",
    icon: "Tool",
    productCount: 2
  }
];

export const brandStory = {
  heritage: {
    title: "40+ Years of American Excellence",
    description: "Born in Dalton, Georgia - the Carpet Capital of the World - AutoMats has been setting the gold standard for quality, sustainability, and production in the U.S. since 1985.",
    stats: [
      { label: "Years in Business", value: "40+" },
      { label: "Facility Size", value: "200,000 sq ft" },
      { label: "Recycled Content", value: "100%" },
      { label: "Virgin Content", value: "0%" }
    ]
  },
  sustainability: {
    title: "Turning Waste Into Value",
    description: "We're the only company making high-performance mats from 100% recycled materials, with zero virgin content. Every AutoMats mat transforms post-industrial and post-consumer waste into premium automotive protection.",
    benefits: [
      "100% recycled materials sourced nationwide",
      "Zero virgin content in all products",
      "Closed-loop manufacturing process",
      "Reduces landfill waste significantly"
    ]
  },
  manufacturing: {
    title: "Made in USA Advantage",
    description: "From formulation to final manufacturing, every step happens in-house at our facility in Dalton, Georgia. This full control ensures unmatched quality, sustainable practices, and faster delivery times.",
    advantages: [
      "No overseas delays or customs hassles",
      "Faster production and delivery times",
      "Consistent quality control",
      "Real cost savings for dealers"
    ]
  },
  margins: {
    title: "Better Margins for Dealers",
    description: "Through efficient operations and domestic production, AutoMats offers high performance at a fraction of the cost of big brands, while providing better profit margins for our dealer partners.",
    benefits: [
      "Competitive wholesale pricing",
      "No tariffs or import fees",
      "Flexible minimum order quantities",
      "Custom branding opportunities"
    ]
  }
};

export const testimonials = [
  {
    id: 1,
    name: "Mike Thompson",
    company: "Southwest Auto Distributors",
    role: "Owner",
    quote: "AutoMats has been our go-to supplier for over 10 years. The quality is consistent, the service is exceptional, and our customers love the sustainability story.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Pacific Coast Auto Parts",
    role: "Purchasing Manager",
    quote: "The fact that these mats are 100% recycled without compromising quality is amazing. Our margins are better and our customers feel good about their purchase.",
    rating: 5
  },
  {
    id: 3,
    name: "Robert Martinez",
    company: "Elite Auto Accessories",
    role: "Regional Manager",
    quote: "Working with AutoMats feels like a true partnership. They understand our business and always deliver on their promises. The custom solutions have been game-changers.",
    rating: 5
  }
];

export const dealerResources = [
  {
    id: 1,
    title: "Product Catalog 2025",
    type: "PDF",
    size: "2.4 MB",
    description: "Complete product specifications and pricing"
  }
];

export const faqs = [
  {
    id: 1,
    question: "What makes AutoMats different from competitors?",
    answer: "AutoMats is the only automotive floor mat brand that combines 100% recycled materials, American manufacturing, faster delivery, and genuine partnership. No competitor offers this unique combination of sustainability, quality, reliability, and service."
  },
  {
    id: 2,
    question: "Are the mats really 100% recycled?",
    answer: "Yes, absolutely. Our mats are crafted using 100% recycled materials with zero virgin content. We source from post-industrial and post-consumer waste across the country, turning what others discard into high-performance automotive protection."
  },
  {
    id: 3,
    question: "What is the minimum order quantity?",
    answer: "Minimum order quantities vary by product, typically ranging from 8 to 50 pieces depending on the mat type. Custom solutions may have different requirements. Contact us for specific MOQ details."
  },
  {
    id: 4,
    question: "Do you offer custom branding options?",
    answer: "Yes, we offer extensive customization including custom logos, colors, and co-branded packaging. Our felt mats can be printed with up to 5 colors, and we provide custom cuts for specific vehicle makes and models."
  },
  {
    id: 5,
    question: "How quickly can orders be fulfilled?",
    answer: "As a domestic manufacturer, we offer much faster turnaround times than overseas suppliers. Most standard orders ship within 1-2 weeks, with no customs delays or tariff complications."
  }
];